// src/components/auth/AuthTokenBridge.js
// Connects Auth0's getAccessTokenSilently to the shared axios instance so every
// API request automatically carries a valid access token. Renders nothing.

import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { registerTokenGetter } from 'api';

export default function AuthTokenBridge() {
    const { getAccessTokenSilently, isAuthenticated } = useAuth0();

    useEffect(() => {
        registerTokenGetter(async () => {
            if (!isAuthenticated) return null;
            try {
                return await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                        scope: 'openid profile email offline_access'
                    }
                });
            } catch (e) {
                // Renewal failing is the actual cause of the 401s the user then
                // sees, but api.js only console.warns it, so the real reason was
                // invisible. Name it loudly — `login_required` or
                // `missing_refresh_token` here means the session can't be renewed
                // and the customer has to sign in again.
                console.error(
                    `[auth] Could not renew the access token (${e?.error || e?.message || 'unknown'}). ` +
                    'The next API call will 401.', e,
                );
                return null;
            }
        });
    }, [getAccessTokenSilently, isAuthenticated]);

    return null;
}
